module.exports = __webpack_public_path__ + "img/device-bg.fdae63ca.png";